import React from 'react'
import { BracketDivider, GamesCol } from './styles'
import type { EventGQL } from '../../../Api'
import { MatchupBox } from './MatchupBox'
import { getShortDate } from '../../../Utils'
import { playoffEventIds } from '../utils'

type MatchupProps = {
  events: EventGQL[]
}

export const QuartersTop: React.FC<React.PropsWithChildren<MatchupProps>> = ({
  events,
}) => {
  const quarterEvents = events.filter((ev) => ev.slugname.includes('quarter'))
  let quarterOne = events.find((ev) => ev.id === playoffEventIds.q1)

  return (
    <>
      <GamesCol>
        <div className="weekCon">
          <h3>Quarterfinals</h3>
          {quarterEvents.length > 0 && <p>{getShortDate(quarterEvents[0].startTime)}</p>}
          {quarterEvents[0].location && <p>{quarterEvents[0].location}</p>}
        </div>
        {quarterEvents.length > 1 && (
          <>
            {quarterOne && <MatchupBox key={quarterOne.slugname} event={quarterOne} />}
          </>
        )}
      </GamesCol>
      <GamesCol>
        <BracketDivider>
          <span></span>
        </BracketDivider>
      </GamesCol>
    </>
  )
}
